<div class="modal-header">
  <h5 class="modal-title">Import Books</h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <p>
    Upload a CSV or Excel file to add multiple books at once.
    <a href="javascript:void(0)" (click)="downloadTemplate()">Download a template</a>
    to see the expected columns.
  </p>

  <div class="form-group">
    <label>
      Required columns:
      <strong>{{ requiredFields.join(', ') }}</strong>.
      All other columns are optional.
    </label>
  </div>

  <div class="form-group">
    <label for="importFile">Choose file (.csv, .xlsx, .xls)</label>
    <input
      type="file"
      id="importFile"
      class="form-control-file"
      accept=".csv,.xlsx,.xls"
      (change)="onFileSelected($event)">
  </div>

  <div class="alert alert-info" *ngIf="selectedFile && !result">
    Selected: {{ selectedFile.name }}
  </div>

  <div *ngIf="uploading" class="alert alert-secondary">
    Importing, please wait...
  </div>

  <div *ngIf="result" class="import-summary">
    <div class="alert" [ngClass]="result.errors.length > 0 ? 'alert-warning' : 'alert-success'">
      Imported {{ result.successCount }} of {{ result.totalRows }} row(s).
    </div>

    <div *ngIf="result.errors.length > 0">
      <p><strong>Rows that were skipped:</strong></p>
      <ul class="import-error-list">
        <li *ngFor="let err of result.errors">{{ err }}</li>
      </ul>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">
    {{ result ? 'Close' : 'Cancel' }}
  </button>
  <button
    type="button"
    class="btn btn-outline-primary"
    *ngIf="!result"
    [disabled]="!selectedFile || uploading"
    (click)="upload()">
    {{ uploading ? 'Importing...' : 'Import' }}
  </button>
  <button
    type="button"
    class="btn btn-outline-primary"
    *ngIf="result"
    (click)="onDoneClick()">
    Done
  </button>
</div>